<template>
  <div>
    <h4 class="" style="font-weight: 500; margin-bottom: 0;">My Candidates</h4>
    <hr>
    <p v-if="relationships.length === 0">No nannies have been linked yet, we're currently searching and you'll be notified shortly!</p>
    <div class="row">
      <!-- <div v-for="(candidate, index) in relationshipCandidates" :key="candidate.id" class="col-lg-4">
        <div class="p-4" style="border: 1px solid var(--bootstrapgrey); border-radius: 2px;">
          <div class="center">
            <img :src="candidate.profile_pic" alt="" style="border-radius: 2px; height: 175px;">
            <h4 class="mt-3" style="margin-bottom: 0;">{{ candidate.first_name }} {{ candidate.last_name }}</h4>
            <p>Status: {{ relationships[index].status }}</p>
            <p>{{ relationships[index] }}</p>
            <div style="margin-top: 20px; margin-bottom: 20px;">
              <router-link
                :to="{ name: 'Candidate Viewable Dashboard', params: { id: candidate.id } }"
                class="mylisting-button dark-button mt-2"
                target="_blank"
              >View Profile</router-link>
            </div>
            <p class="" v-if="relationships[index].status == 'Under Consideration'"><span style="cursor: pointer;" @click="updateRelationshipStatus('Interested', relationships[index])">I'm Interested</span> | <span style="cursor: pointer;" @click="updateRelationshipStatus('Not Interested', relationships[index])">I'm Not Interested</span></p>
          </div>
        </div>
      </div> -->
      <div v-for="relationship in relationships" :key="relationship.id" class="col-lg-4">
        <div class="p-4" style="border: 1px solid var(--bootstrapgrey); border-radius: 2px;">
          <div class="center">
            <h4 class="mt-3" style="margin-bottom: 0;">{{ relationship.candidate_name }}</h4>
            <p>Status: {{ relationship.status }}</p>
            <div style="margin-top: 20px; margin-bottom: 20px;">
              <router-link
                :to="{ name: 'Candidate Viewable Dashboard', params: { id: relationship.candidate } }"
                class="mylisting-button dark-button mt-2"
                target="_blank"
              >View Profile</router-link>
            </div>
            <p class="" v-if="relationship.status == 'Under Consideration'"><span style="cursor: pointer;" @click="updateRelationshipStatus('Interested', relationship)">I'm Interested</span> | <span style="cursor: pointer;" @click="updateRelationshipStatus('Not Interested', relationship)">I'm Not Interested</span></p>
            <button v-if="relationship.status == 'Interested'" class="mylisting-button dark-button" @click="showOfferModal(relationship)">Extend Offer</button>
          </div>
        </div>
      </div>
    </div>

    <modal name="schedule-interview-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thanks for letting us know you are interested!</h2>
        <p>The next step is for us to schedule an interview/trial day with you and the nanny. Please fill in this form:</p>
        <hr>
        <div class="field-of-fields">
          <label style="margin-top: 0;">Would you prefer to start with a video meeting or in person?</label>
          <input type="text" class="form-control" v-model="videoOrInPerson">
          <label>Please let us know some upcoming days and times when you are available</label>
          <textarea rows="4" class="form-control" v-model="availability"></textarea>
        </div>
        <hr>
        <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('job-updated-modal')" style="">Close</button> -->
        <button class="mylisting-button dark-button mb-5" style="float: right;" @click="submitScheduleForm()">Submit</button>
      </div>
    </modal>

    <modal name="extend-offer-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Extend an Offer</h2>
        <p>Thanks for your interest in hiring this nanny. To extend an offer, please fill in the following details:</p>
        <hr>
        <div class="field-of-fields">
          <label style="margin-top: 0;">Expected days and hours</label>
          <!-- <input type="text" class="form-control" v-model="daysHours"> -->
          <textarea rows="3" class="form-control" v-model="daysHours"></textarea>
          <label>Pay rate</label>
          <input type="text" class="form-control" v-model="payRate">
          <label>Paid time off</label>
          <textarea rows="3" class="form-control" v-model="paidTimeOff"></textarea>
          <label>Anticipated start date</label>
          <input type="text" class="form-control" v-model="startDate">
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('extend-offer-modal')" style="">Close</button>
        <button class="mylisting-button dark-button mb-5" style="float: right;" @click="extendOffer()">Submit</button>
      </div>
    </modal>

    <modal name="submitted-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Thanks, we will be in touch shortly!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('submitted-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      relationships: [],
      relationship: {},
      relationshipCandidates: [],

      videoOrInPerson: '',
      availability: '',

      daysHours: '',
      payRate: '',
      paidTimeOff: '',
      startDate: '',
    }
  },
  created() {
    // this.candidateEmployerRelationshipStatuses = this.$store.getters.candidateEmployerRelationshipStatuses
    this.getRelationships()
  },
  methods: {
    getRelationships() {
      axios.get(`/api/relationships/?employer=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.relationships = res.data
          this.relationships = this.relationships.sort((a, b) => (a.id < b.id) ? 1 : -1)

          // this.relationshipCandidates = []
          // for (var relationship in this.relationships) {
          //   axios.get(`/api/people/?id=${this.relationships[relationship].candidate}`)
          //     .then(res => {
          //       console.log(res)
          //       // this.relationshipCandidates.push(res.data[0])
          //       // https://stackoverflow.com/questions/35817565/how-to-filter-array-when-object-key-value-is-in-array
          //       // let correspondingRelationship = this.relationships.filter( x => x.candidate == res.data[0].id )[0]
          //       // console.log(correspondingRelationship)
          //       // this
          //     })
          //     .catch(error => console.log(error));
          // }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateRelationshipStatus(status, relationship) {
      console.log(status)
      console.log(relationship)

      if (status == 'Interested') {
        this.relationship = relationship
        this.$modal.show('schedule-interview-modal')
      }

      axios.patch(`/api/relationships/${relationship.id}/`, {
        status: status
      })
        .then(res => {
          console.log(res)
          this.getRelationships()
        })
        .catch(error => console.log(error));
    },
    submitScheduleForm() {
      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        text1: this.videoOrInPerson,
        text2: this.availability,
      })
        .then(res => {
          this.$modal.hide('schedule-interview-modal')
          this.$modal.show('submitted-modal')

          this.$store.dispatch('sendEmails',
            {
              subject: `Client ${this.relationship.employer_name} Interested in ${this.relationship.candidate_name}`,
              message: 'Hello,' + '\n\n' +
              `The client ${this.relationship.employer_name} is interested in the nanny ${this.relationship.candidate_name}!\n` +
              `Client meeting preference: ${this.videoOrInPerson}\n` +
              `Client availability: ${this.availability}\n\n` +
              `Cheers!`,
              from: this.$store.getters.agencyFromEmail,
              // emails: [this.$store.getters.enginehireAdminEmail, this.user.selector9],
              emails: [this.$store.getters.enginehireLoggingEmail, this.user.selector9],
              reply: this.$store.getters.agencyReplyEmail,
              userID: 4,
            }
          )
        })
        .catch(error => console.log(error))
    },
    showOfferModal(relationship) {
      this.relationship = relationship
      this.$modal.show('extend-offer-modal')
    },
    extendOffer() {
      axios.patch(`/api/relationships/${this.relationship.id}/`, {
        text3: this.daysHours,
        text4: this.payRate,
        text5: this.paidTimeOff,
        text6: this.startDate,
        status: 'Offer Extended',
      })
        .then(res => {
          this.$modal.hide('extend-offer-modal')
          this.$modal.show('submitted-modal')
          this.getRelationships()

          this.$store.dispatch('sendEmails',
            {
              subject: `Client ${this.relationship.employer_name} extended offer to ${this.relationship.candidate_name}`,
              message: 'Hello,' + '\n\n' +
              `The client ${this.relationship.employer_name} has extended an offer to the nanny ${this.relationship.candidate_name}!\n` +
              `Days and hours: ${this.daysHours}\n` +
              `Pay rate: ${this.payRate}\n` +
              `Paid time off: ${this.paidTimeOff}\n` +
              `Start date: ${this.startDate}\n\n` +
              `Cheers!`,
              from: this.$store.getters.agencyFromEmail,
              // emails: [this.$store.getters.enginehireAdminEmail],
              emails: [this.$store.getters.enginehireAdminEmail, this.user.selector9],
              reply: this.$store.getters.agencyReplyEmail,
              userID: 4,
            }
          )
        })
        .catch(error => console.log(error))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/MyCandidates.vue